







































import { appStoreUrl, googlePlayUrl } from '@/utils/constants'
import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class Share extends Vue {
  appStoreUrl = appStoreUrl
  googlePlayUrl = googlePlayUrl
}

